export default __webpack_public_path__ + "static/media/Cream1.41c3555f.jpg";